import {LoadingAnimation} from '../../components/loading-animation/LoadingAnimation';
import {GetStartedWizard} from './components/wizard/GetStartedWizard';
import {useNavigate} from 'react-router-dom';
import {useEffect, useState} from 'react';
import {useAppSelector} from '../../hooks';
import {useAuth} from '../../store/AuthProvider';
import {UserSelector} from '../../store/user/UserSelector';
import {RootRoute} from '../../routes/RootRoute';
import {getFallbackRoute} from '../../utils/auth/validateReturnUrlPermissions';

export const SceneGetStarted = () => {
  const navigate = useNavigate();
  const {user, isAdmin} = useAuth();
  const userDetails = useAppSelector(UserSelector.getUserDetails);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      // Not authenticated - redirect to login
      navigate(RootRoute.LogIn, {replace: true});
      return;
    }

    // Give userDetails a chance to load, but don't wait forever
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    if (userDetails) {
      setIsLoading(false);
      clearTimeout(timeout);

      if (userDetails.companyId !== 'UNKNOWN_COMPANY') {
        // Already has company - redirect to dashboard
        navigate(getFallbackRoute(isAdmin || false), {replace: true});
        return;
      }
    }

    return () => clearTimeout(timeout);
  }, [user, userDetails, navigate, isAdmin]);

  if (!user) {
    return <LoadingAnimation overwriteIsBusy />;
  }

  if (isLoading) {
    return <LoadingAnimation overwriteIsBusy />;
  }

  // Allow rendering even if userDetails hasn't loaded yet for UNKNOWN_COMPANY users
  if (userDetails && userDetails.companyId !== 'UNKNOWN_COMPANY') {
    return <LoadingAnimation overwriteIsBusy />;
  }

  return (
    <div
      style={{
        height: '100vh',
        width: '100%',
        overflow: 'hidden',
      }}>
      <GetStartedWizard />
    </div>
  );
};
